// Shared bizSAFE-expiry cell — renders the single-source-of-truth rule from lib/expiry.
// Renewal vs New is determined ONLY by whether a bizSAFE expiry exists (callers resolve the date via
// resolveExpiry). No date → "New application". Overdue is shown red + bold with a clear chip.
import React from 'react'
import { format, parseISO } from 'date-fns'
import { expiryTier } from '../lib/expiry'

export default function ExpiryBadge({ date }) {
  if (!date) return <span style={{ color: 'var(--text3)' }}>New application</span>
  const t = expiryTier(date)
  if (!t) return <span style={{ color: 'var(--text3)' }}>—</span>
  const danger = t.tier === 'overdue' || t.tier === 'urgent'
  return (
    <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center', whiteSpace: 'nowrap' }}>
      <span style={{ fontSize: 13, color: danger ? 'var(--danger)' : undefined, fontWeight: t.tier === 'overdue' ? 600 : undefined }}>
        {t.tier === 'overdue' && '⚠ '}{format(parseISO(date), 'd MMM yyyy')}
      </span>
      {t.tier !== 'ok' && <span className={`badge ${t.badge}`} style={{ fontSize: 13 }}>{t.label}</span>}
    </span>
  )
}
